import { FormulaId, SAVINGS_ROWS_BY_FORMULA } from "../data/savings";
import { AlertIcon } from "./icons/AlertIcon";
import { CheckIcon } from "./icons/CheckIcon";

const HEART_MEMBER_ICON = "/assets/pack-zero-franchise/heart-member.svg";

interface Props {
  formulaId: FormulaId;
}

const WARNING_COLOR = "#B6103C";
const SUCCESS_COLOR = "#05702F";
const DIVIDER = "border-t border-[#0D0D0D]/10";
const WHITE_CELL_SHADOW = "shadow-[0_2px_8px_rgba(13,13,13,0.06),0_0_5px_rgba(13,13,13,0.04)]";
const DARK_CELL_BG = "bg-black/5";

export const SavingsTable = ({ formulaId }: Props) => {
  const rows = SAVINGS_ROWS_BY_FORMULA[formulaId];

  return (
    <div className="relative w-full max-w-[744px] py-5">
      <div
        aria-hidden
        className={`pointer-events-none absolute bottom-0 right-0 top-0 w-[35%] rounded-[24px] bg-white md:w-[30%] ${WHITE_CELL_SHADOW}`}
      />
      <table className="relative w-full table-fixed border-separate border-spacing-0 text-left text-[13px] tracking-[0.26px] text-[#0D0D0D] md:text-[16px] md:tracking-normal">
        <thead>
          <tr>
            <th
              scope="col"
              className="w-[30%] pb-6 pr-4 align-bottom text-left text-[13px] [font-weight:600] md:w-[40%] md:text-[19px]"
            >
              Cas concrets
            </th>
            <th
              scope="col"
              className={`w-[35%] rounded-tl-[24px] ${DARK_CELL_BG} px-4 pb-6 align-bottom text-center text-[13px] [font-weight:600] md:w-[30%] md:text-[19px]`}
            >
              Sans Roole<sup>*</sup>
            </th>
            <th
              scope="col"
              className="w-[35%] px-4 pb-6 text-center text-[13px] [font-weight:600] md:w-[30%] md:text-[19px]"
            >
              <div className="flex flex-col items-center gap-1">
                <img src={HEART_MEMBER_ICON} alt="" width={24} height={24} />
                <span>
                  Avec Roole<sup>**</sup>
                </span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              <td className={`${DIVIDER} py-4 pr-4`}>{row.scenario}</td>
              <td className={`${DIVIDER} ${DARK_CELL_BG} px-4 py-4`}>
                <div className="flex justify-center">
                  <span className="inline-flex items-center gap-1 text-left [font-weight:600]">
                    <AlertIcon size={16} color={WARNING_COLOR} className="shrink-0" />
                    {row.withoutRoole}
                  </span>
                </div>
              </td>
              <td className={`${DIVIDER} px-4 py-4`}>
                <div className="flex justify-center">
                  <span
                    className="inline-flex items-center gap-1 text-left [font-weight:600]"
                    style={{ color: SUCCESS_COLOR }}
                  >
                    <CheckIcon size={16} color={SUCCESS_COLOR} className="shrink-0" />
                    {row.withRoole}
                  </span>
                </div>
              </td>
            </tr>
          ))}

          <tr>
            <td className={`${DIVIDER} py-4 pr-4`}>Sérénité</td>
            <td className={`${DIVIDER} ${DARK_CELL_BG} rounded-bl-[24px] px-4 py-4 text-center`}>
              <span className="inline-flex items-center gap-1 [font-weight:600]">
                <AlertIcon size={16} color={WARNING_COLOR} className="shrink-0" />
                Variable
              </span>
            </td>
            <td className={`${DIVIDER} relative px-4 pt-4 text-center`}>
              <GuaranteeBadge />
              <span
                className="inline-flex items-center gap-2 [font-weight:600] px-2"
                style={{ color: SUCCESS_COLOR }}
              >
                Sérénité totale
                <img
                  className="shrink-0"
                  src="/assets/pack-zero-franchise/glitter.svg"
                  alt=""
                  aria-hidden
                  width={20}
                  height={20}
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const GuaranteeBadge = () => (
  <img
    src="/assets/pack-zero-franchise/hundred-percent-star.svg"
    alt=""
    aria-hidden="true"
    className="pointer-events-none absolute left-0 top-1/2 z-10 h-[53px] w-[53px] -translate-x-1/2 -translate-y-1/2 md:h-[64px] md:w-[64px] mt-2"
  />
);
